// This is the main vuex store file that configures the store with all of the above vuex modules.

import Vue from 'vue'
import Vuex from 'vuex'

import { counterRequests } from './modules/counter.requests.module'
import { helper } from './modules/helper.module'
import { auth } from './modules/auth.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    counterRequests,
    helper,
    auth
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js